import React from 'react';
import SubHeader from '../../components/Layout/SubHeader';
import OtpInput from 'react-otp-input';
import { getAuthToken, storeUserData } from '../../components/Util';
import axios from 'axios';
import api from '../../config/api';
import { toast } from 'react-toastify';
import strings from '../../components/Language';
import { ProgressBar } from 'react-loader-spinner';

class PasswordUpdateScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ProgressBar: false,
            lang: strings.getLanguage(),
            access_token: null,
            old_password: null,
            password: null,
            re_password: null,
        }
    }

    async componentDidMount() {
        let self = this;
        var token = await getAuthToken();

        if (token) {
            self.setState({ access_token: token });
            await storeUserData(token, this);
        }
    }

    onPressSavePassword() {
        const self = this;
        self.setState({ 'isLoading': true })
        
        if (!this.state.old_password) {
            toast.error(strings["Old Password Required"]);
            return false;
        }
        if (!this.state.password) {
            toast.error(strings["Password Required"]);
            return false;
        }
        if (!this.state.re_password) {
            toast.error(strings["Confirm Password Required"]);
            return false;
        }
        if (this.state.password != this.state.re_password) {
            toast.error(strings["Password and Confirm Password not match"]);
            return false;
        }
        self.setState({ ProgressBar: true });

        axios.post(api.LoginPassword, {
            new_password: this.state.password,
            confirm_new_password: this.state.re_password,
            old_password: this.state.old_password,
            lang: this.state.lang
        }, {
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json',
            }
        }).then(function (response) {
            self.setState({ 'isLoading': false });
            self.setState({ ProgressBar: false });
            if (response.data.error == 202 || response.data.error == '202') {
                if (response.data.errors && response.data.errors.length != 0) {
                    self.setState({ errorMessage: response.data.errors });
                } else {
                    var err_result = response.data.message.split("\r\n");
                    err_result.forEach(data => {
                        if (data) {
                            toast.error(data);
                        }
                    });
                }
            } else {
                toast.success(response.data.message);
                self.timeoutHandle = setTimeout(() => {
                    localStorage.clear();
                    window.location.reload(false);
                }, 1000);
                return false;
            }
        }).catch(function (error) {
            self.setState({ ProgressBar: false });
            toast.error(strings["no_internet"]);
        });
    }

    render() {
        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                <SubHeader data={{ title: strings["passwordUpdate"] }} />

                <div className='passwordUpdateScreen'>
                    <main className="reset-container">
                        <form className="reset-password">
                            <div className="form-group">
                                <label id="oldPasswordLabel">{strings["oldPasswordLabel"]}<span>*</span></label>
                                <div className="password-code">
                                    <OtpInput
                                        value={this.state.old_password}
                                        onChange={(old_password) => this.setState({ old_password: old_password })}
                                        numInputs={6} // Number of OTP input fields
                                        renderInput={(props) => <input {...props} />}
                                        inputStyle="password-input"
                                        inputType='password'
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label id="retypePasswordLabel">{strings["retypePasswordLabel"]}<span>*</span></label>
                                <div className="password-code">
                                    <OtpInput
                                        value={this.state.password}
                                        onChange={(password) => this.setState({ password: password })}
                                        numInputs={6} // Number of OTP input fields
                                        renderInput={(props) => <input {...props} />}
                                        inputStyle="password-input"
                                        inputType='password'
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label id="retypePasswordLabel">{strings["retypePasswordLabel"]}<span>*</span></label>
                                <div className="password-code">
                                    <OtpInput
                                        value={this.state.re_password}
                                        onChange={(re_password) => this.setState({ re_password: re_password })}
                                        numInputs={6} // Number of OTP input fields
                                        renderInput={(props) => <input {...props} />}
                                        inputStyle="password-input"
                                        inputType='password'
                                    />
                                </div>
                            </div>

                            <div className="button-wrap">
                                <button onClick={() => this.onPressSavePassword()} type="button" id="submitButton" className="submit-button">
                                    {strings["submitButton"]}
                                </button>
                            </div>
                        </form>
                    </main>
                </div>
            </>
        );
    }
}

export default PasswordUpdateScreen;
